/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The SectionVo model module.
   * @module textbook/model/SectionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>SectionVo</code>.
   * @alias module:textbook/model/SectionVo
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>SectionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/SectionVo} obj Optional instance to populate.
   * @return {module:textbook/model/SectionVo} The populated <code>SectionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'lessonId')) {
        obj['lessonId'] = ApiClient.convertToType(data['lessonId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'seenToc')) {
        obj['seenToc'] = ApiClient.convertToType(data['seenToc'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'filePath')) {
        obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'fileUrl')) {
        obj['fileUrl'] = ApiClient.convertToType(data['fileUrl'], 'String');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 课id
   * @member {Integer} lessonId
   */
  exports.prototype['lessonId'] = undefined;
  /**
   * 名称
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 在目录中是否可见
   * @member {Boolean} seenToc
   */
  exports.prototype['seenToc'] = undefined;
  /**
   * 0课时练习 1扩展阅读 2扩展视频 3课文录音 4AI情景对话 5考试
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 文件路径 仅type为1扩展阅读、2扩展视频时有值
   * @member {String} filePath
   */
  exports.prototype['filePath'] = undefined;
  /**
   * 文件路径 仅type为1扩展阅读、2扩展视频时有值
   * @member {String} fileUrl
   */
  exports.prototype['fileUrl'] = undefined;



  export default exports;
;


